import { lazy } from "react";

const Projects = lazy(() => import("@/pages/projects/Projects"));

export const projects = [
  {
    path: "/projects",
    layout: "decisively",
    role: ["project-reader", "project-writer", "project-technical"],
    exact: true,
    component: Projects,
  },
];
